import Vue from 'vue'
import App from './App.vue'
import VueRouter from 'vue-router'
import router from './router'
import AUTH from './mixins/auth'
import META from './mixins/meta'
import store from './store/index'
import { sync } from 'vuex-router-sync'
import axios from 'axios'
import VueAxios from 'vue-axios'
import AxiosInterceptor from './helpers/http-interceptors'
import Moment from './helpers/moment'
import { abilitiesPlugin, Can } from '@casl/vue'
import ability from './helpers/ability'
import sentryTracker from '@/helpers/trackers/sentry.js'
import titleHelper from '@/helpers/title.js'
import toCurrency from '@/filters/toCurrency'
import parse from '@/filters/parse'
import truncateText from '@/filters/truncateText'
import emptyInput from '@/directives/emptyInput'
import inputModel from '@/directives/inputModel'
import metricColor from '@/directives/metricColor'
import listGroupActive from '@/directives/listGroupActive'
import swipeMenu from '@/directives/swipeMenu'
import watchMenuState from '@/directives/watchMenuState'
import notify from './notify'
import satismeter from './satismeter'
import VueObserveVisibility from 'vue-observe-visibility'
import VueRx from 'vue-rx'
import BootstrapVue from 'bootstrap-vue'
import Clipboard from 'v-clipboard'
import { projectAuth } from '@/firebase/config'

import 'roboto-fontface/css/roboto/sass/roboto-fontface-regular.scss'
import 'vue-select/dist/vue-select.css'

import './lib/tourguide/css/tour.min.css'

Vue.component('Can', Can)
Vue.use(abilitiesPlugin, ability())
Vue.use(VueRouter)
Vue.use(VueObserveVisibility)
Vue.use(BootstrapVue)
Vue.use(VueRx)
Vue.use(Clipboard)
Vue.filter('toCurrency', toCurrency)
Vue.filter('parse', parse)
Vue.filter('truncateText', truncateText)
Vue.directive('empty-input', emptyInput)
Vue.directive('metric-color', metricColor)
Vue.directive('list-group-active', listGroupActive)
Vue.directive('swipe-menu', swipeMenu)
Vue.directive('watch-menu-state', watchMenuState)
Vue.directive('$model', inputModel)

AxiosInterceptor()

Moment(Vue)

Vue.use(VueAxios, axios)

const unsync = sync(store, router) // TODO: verificar necessidade da parada

let app
projectAuth.onAuthStateChanged(async () => {
  if (!app) {
    // eslint-disable-next-line no-console
    console.log('[main] starting app')
    app = new Vue({
      el: '#app',
      router,
      store,
      components: { App },
      template: '<App/>',
      mixins: [AUTH, META],
      beforeCreate: function() {
        sentryTracker.register(this)
        titleHelper.register(this)
        notify.register(this)
        satismeter.register(this)
      },
    })
  }
})

if (window.Cypress) {
  // only available during E2E tests
  window.app = app
}

// During app/Vue teardown (e.g., you only use Vue.js in a portion of your app and you
// navigate away from that portion and want to release/destroy Vue components/resources)
unsync() // Unsyncs store from router
